import { SnowflakeCategoryIcon } from "@assets/icons";
import { DatabricksIcon } from "@assets/images";
import { DbtIcon } from "@/assets/icons";
import type { TablerIcon } from "@tabler/icons-react";
import {
  IconTrendingUp,
  IconDatabase,
  IconBolt,
  IconServer,
  IconUsers,
  IconFileText,
  IconLayoutGrid,
} from "@tabler/icons-react";
import React from "react";

export type Platform = "snowflake" | "databricks";

export const GROUP_ICON_MAP: Record<string, TablerIcon> = {
  "trending-up": IconTrendingUp,
  database: IconDatabase,
  zap: IconBolt,
  "hard-drive": IconServer,
  users: IconUsers,
  "file-text": IconFileText,
};

export const GROUP_CUSTOM_ICON_MAP: Record<string, React.ReactNode> = {
  "git-branch": React.createElement(DbtIcon, { className: "al-w-4 al-h-4" }),
};

export const DEFAULT_GROUP_ICON = IconLayoutGrid;

export const PLATFORMS: {
  id: Platform;
  label: string;
  Icon: React.ElementType<{ size?: number; className?: string }>;
}[] = [
  { id: "snowflake", label: "Snowflake", Icon: SnowflakeCategoryIcon },
  { id: "databricks", label: "Databricks", Icon: DatabricksIcon },
];
